export default __webpack_public_path__ + "static/google-reviews-white-f9753143d85a43300add21edea11da73.svg";